var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardDetailmultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 16.6667V18.277C6.6665 18.5072 6.47995 18.6937 6.24984 18.6937C6.15236 18.6937 6.05798 18.6595 5.9831 18.5971L2.55061 15.7367C2.37383 15.5894 2.34995 15.3267 2.49726 15.1499C2.57643 15.0549 2.6937 15 2.81736 15H14.9998C15.9203 15 16.6665 14.2537 16.6665 13.3333V6.66664H18.3332V13.3333C18.3332 15.1742 16.8408 16.6667 14.9998 16.6667H6.6665ZM13.3332 3.3333V1.72291C13.3332 1.49279 13.5198 1.30624 13.7498 1.30624C13.8473 1.30624 13.9417 1.34042 14.0166 1.40282L17.4491 4.26322C17.6258 4.41054 17.6498 4.67328 17.5024 4.85006C17.4233 4.94505 17.306 4.99998 17.1823 4.99998L4.99984 4.99997C4.07936 4.99997 3.33317 5.74616 3.33317 6.66664V13.3333H1.6665V6.66664C1.6665 4.82569 3.15889 3.3333 4.99984 3.3333H13.3332Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardDetailmultiple);
export default __webpack_public_path__ + "static/media/rewardDetailmultiple.21871299b95c17dbd10c793e1719aa54.svg";
export { ForwardRef as ReactComponent };